import { render, staticRenderFns } from "./DialogAssignResponsable.vue?vue&type=template&id=346640fe"
import script from "./DialogAssignResponsable.vue?vue&type=script&lang=js"
export * from "./DialogAssignResponsable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports